import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { CloseOnOutsideDirective } from '@awread/global/packages';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { CopyClipboardDirective } from '../../directives/copy-clipboard/copy-clipboard.directive.js';

@Component({
  standalone: true,
  selector: 'wrt-menu-btn',
  imports: [CommonModule, FontAwesomeModule, CloseOnOutsideDirective, CopyClipboardDirective],
  templateUrl: './wrt-menu-btn.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WrtMenuBtnAtom implements OnInit {
  @Input() btns: any[] = [];
  @Input() faIconComments = faEllipsisH;
  @Output() chapterActionEvent = new EventEmitter();
  @Input() previewLink = ['https://awread.vn', 'c', 'xyz'];

  isMenuOpen = false;
  @Input() book!: any;
  constructor() {}
  toggleMenu(event: any) {
    event.stopPropagation();
    this.isMenuOpen = !this.isMenuOpen;
  }

  onClick() {
    this.isMenuOpen = false;
  }

  ngOnInit(): void {}
}
